import BaseComponent from "../../../baseComponent.js";
import PieWidget from "../../widgets/pie-chart/pieWidget.jsx";

export default class Pie extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <PieWidget widgetId={this.props.model.id}
                 widget={this.props.model}
                 components={this.props.components}
                 togglePreloader={() => true}
                 legends={this.props.model.legends}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/widgets/pie.jsx